export default __webpack_public_path__ + "static/media/029-football-ball.c8d87ec3.svg";